// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * A configured action button for a specific bank.
 *
 * Composite PK (message_id, bank_id) in `PostgreSQL`.
 * Which drawer a configured button belongs in, derived from the intra-content
 * flags on the KEY that carries the bound command.
 *
 * This is a different question from `lift_id`. `lift_id` records which car the
 * wizard SCOPED an action to; `ActionScope` records how the vendor ENCODES the
 * command — a unit-based key addresses one car, a bank-level key addresses the
 * whole group. The two can disagree, and when they do the encoding is what
 * decides where the button can meaningfully be pressed.
 *
 * UNKNOWN is a real state, not a placeholder: two booleans could not express
 * it, because a bank-level command legitimately has `units_based = false` and
 * would be indistinguishable from a server that never answered. A consumer
 * seeing UNKNOWN must fall back to its previous behaviour rather than assume
 * either scope — the same lesson as `position: bool` below.
 */
export enum ActionScope {
  UNKNOWN = 0,
  UNIT = 1,
  BANK = 2,
}
